<template>
  <div style="width: 100%">
    <v-chip-group
      v-for="(chipGroup, groupIndex) in chipGroups"
      :key="groupIndex"
      v-model="categoriaListagemSelecionada"
      column
      @change="handleSelectCategoria"
    >
      <v-chip
        v-for="(chip, index) in Object.values(chipGroup)"
        :key="index"
        filter
        :value="chip.value"
        :color="chip.color"
      >
        {{ chip.text }}
        {{ chip.qtd }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { ref, watchEffect } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import useTicketListCategoriaStatusContadores from '@/composables/useTicketListCategoriaStatusContadores'
import TicketCategoriaStatusChipEnum from '@/models/entities/ticket/TicketCategoriaStatusChipEnum'
import useUserStore from '@/store/user'

export default {
  props: {
    filaId: {
      type: Number,
      default: null,
    },
    isGestor: {
      type: Boolean,
      required: true,
    },
    filtroEmail: {
      type: String,
      default: null,
    },
    filtroProtocolo: {
      type: String,
      default: null,
    },
    filtroCategoriaListagem: {
      type: Number,
      default: null,
    },
    filtroAgenteSelecionado: {
      type: Number,
      default: null,
    },
  },

  setup(props, { emit }) {
    const { id: atendenteId } = storeToRefs(useUserStore())

    const categoriaListagemSelecionada = ref(TicketCategoriaStatusChipEnum.Ativos)

    watchEffect(() => { categoriaListagemSelecionada.value = props.filtroCategoriaListagem })

    function mudarFocoParaOPrimeiroChip() {
      const firstChip = document.querySelector('.v-chip')
      if (!firstChip) return
      firstChip.focus()
    }

    function handleSelectCategoria(id) {
      categoriaListagemSelecionada.value = id || TicketCategoriaStatusChipEnum.Ativos

      if (categoriaListagemSelecionada.value === TicketCategoriaStatusChipEnum.Ativos) {
        mudarFocoParaOPrimeiroChip()
      }
      emit('update:filtro-categoria-listagem', categoriaListagemSelecionada.value)
    }

    const filtrosLocale = ref({ email: '', protocolo: '', agenteSelecionado: '' })

    watchEffect(() => {
      filtrosLocale.value = {
        email: props.filtroEmail,
        protocolo: props.filtroProtocolo,
        agenteSelecionado: props.filtroAgenteSelecionado,
      }
    })

    const chipGroups = useTicketListCategoriaStatusContadores(props.filaId, props.isGestor ? null : atendenteId, filtrosLocale)

    return {
      categoriaListagemSelecionada,
      handleSelectCategoria,
      chipGroups,
    }
  },
}
</script>
